import { Component, inject, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ApiErrorService } from '../../services/api-error.service';

/**
 * Modal global com todos os erros devolvidos pelo backend (aberto pelo "Ver mais" do toast).
 * Montado uma vez em `app.component.html`; o estado vive no `ApiErrorService`.
 */
@Component({
  selector: 'app-api-error-modal',
  imports: [TranslateModule],
  templateUrl: './api-error-modal.component.html',
})
export class ApiErrorModalComponent {
  protected readonly apiErrors = inject(ApiErrorService);
  protected readonly copied = signal(false);

  protected close(): void {
    this.copied.set(false);
    this.apiErrors.closeDetails();
  }

  protected copyTraceId(traceId: string): void {
    navigator.clipboard?.writeText(traceId).then(
      () => this.copied.set(true),
      () => this.copied.set(false)
    );
  }
}
